import React, { useEffect, useState } from 'react';
import { getUploadedImagePath, MarkupRender, Scrollbar, ToggleMenu, useBreakpoints } from '@nutastic/nutastic-react-app';
import classnames from 'classnames';
import OrderRequestForm from '../OrderRequestForm';

// eslint-disable-next-line react/prop-types
const ShopCategoryPage = ({ category = {}, isOpen, onClose, onPriceSheetClick }) => {
    const componentClass = 'shopCategoryPage';
    const [shouldShowForm, setShouldShowForm] = useState(false);
    const { lg: isLargeScreen } = useBreakpoints();
    const ImageWrapper = isLargeScreen ? Scrollbar : React.Fragment;
    const contentClasses = classnames(`${componentClass}__content`, 'animated', {
        fadeOutLeft: shouldShowForm,
        fadeIn: !shouldShowForm
    });
    const formClasses = classnames(`${componentClass}__form`, 'animated', {
        'd-none': !shouldShowForm,
        fadeInRight: shouldShowForm
    });

    const { categoryImages = [], content, title, num_4: useForm, field_1: tagText } = category;

    const onOuterClick = () => {
      if (!shouldShowForm) onClose();
    };

    useEffect(() => {
        if (!isOpen) setShouldShowForm(false);
    }, [isOpen]);

    return <ToggleMenu
        className={componentClass}
        isOpen={isOpen}
        animation="slideFromRight"
        onOuterClick={onOuterClick}
    >
        <div className={`${componentClass}__actions`}>
            { shouldShowForm && <i className="ion-md-arrow-back mr-4" onClick={() => setShouldShowForm(false)} /> }
            <i className="ion-md-close" onClick={onClose} />
        </div>
        <span className={`${componentClass}__tag`}>{ tagText }</span>
        <span className={`${componentClass}__whiteStrip`} />

        <div className={contentClasses}>
            <div className={`${componentClass}__textDetails`}>
                <h1>{ title }</h1>
                <MarkupRender content={content} className="paragraph-content" tagName="div" />
                { (useForm || 0).toString() === '1' && <div className={`${componentClass}__buttons`}>
                    <button className="btn btn-outline-black" onClick={onPriceSheetClick}>View Prices</button>
                    <button className="btn btn-black" onClick={() => setShouldShowForm(true)}>Place An Order</button>
                </div> }
            </div>
            <div className={`${componentClass}__images`}>
                <ImageWrapper>
                    {
                        (categoryImages || []).map((banner, index) => {
                            return <img src={getUploadedImagePath(banner.image)} alt={`${title} | Image #${index} | Manifesting Vibes Waco`} key={index} />;
                        })
                    }
                </ImageWrapper>
            </div>
        </div>

        <div className={formClasses}>
            { isOpen && <OrderRequestForm type={title} onComplete={() => setShouldShowForm(false)} /> }
        </div>
    </ToggleMenu>;
};

export default ShopCategoryPage;
